/* unplugin-vue-components disabled */import { render } from "./PiggyBankIcon.vue?vue&type=template&id=29107b26"
import script from "./PiggyBankIcon.vue?vue&type=script&lang=js"
export * from "./PiggyBankIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__